import {
  type PropsWithChildren,
  createContext,
  useContext,
  useState
} from 'react';

import { ValueOf } from 'reservations/base/types/common';

export const SUBMISSION_TYPES = {
  CREATE_FORM: 'create',
  MODIFY_FORM: 'modify',
  WAITLIST_FORM: 'waitlist'
};
export type SubmissionType = ValueOf<typeof SUBMISSION_TYPES>;

export const DRAWER_STATES = {
  INPUT_FIELDS: 'input_fields',
  REPLACE_CARD: 'replace_card'
};
export type DrawerState = ValueOf<typeof DRAWER_STATES>;

interface BookingFormContext {
  submissionType: SubmissionType;
  setSubmissionType: (submissionType: SubmissionType) => void;
  drawerState: DrawerState;
  setDrawerState: (drawerState: DrawerState) => void;
  isCreate: boolean;
  isModify: boolean;
  isWaitlist: boolean;
}
export const BookingFormContext = createContext<BookingFormContext | null>(
  null
);

export const BookingFormProvider = ({ children }: PropsWithChildren) => {
  const [submissionType, setSubmissionType] = useState<SubmissionType>(
    SUBMISSION_TYPES.CREATE_FORM
  );
  const [drawerState, setDrawerState] = useState<DrawerState>(
    DRAWER_STATES.INPUT_FIELDS
  );

  const isCreate = submissionType === SUBMISSION_TYPES.CREATE_FORM;
  const isModify = submissionType === SUBMISSION_TYPES.MODIFY_FORM;
  const isWaitlist = submissionType === SUBMISSION_TYPES.WAITLIST_FORM;

  return (
    <BookingFormContext.Provider
      value={{
        drawerState,
        setDrawerState,
        submissionType,
        setSubmissionType,
        isCreate,
        isModify,
        isWaitlist
      }}
    >
      {children}
    </BookingFormContext.Provider>
  );
};

export const useBookingForm = () => {
  const context = useContext(BookingFormContext);
  if (context == null) {
    throw new Error('useBookingForm must be used within BookingFormProvider');
  }

  return context;
};
